import { render, staticRenderFns } from "./HotwordsBar.vue?vue&type=template&id=8d906702"
import script from "./HotwordsBar.vue?vue&type=script&lang=js"
export * from "./HotwordsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports